import { Type, optional } from 'specified';
import { positiveIntegerSpec, integerAbove0, isoDateSpec, integerSpec } from '../../specs-utils.js';

const currencySpec = Type.literal({
    EUR: 1,
    GBP: 1
});
const moneySpec = Type.interface({
    amount: positiveIntegerSpec,
    currency: currencySpec,
    precision: integerAbove0
});
const deliverySpec = Type.interface({
    reference: optional(Type.string),
    date: isoDateSpec,
    boxesPerEyeSide: optional(positiveIntegerSpec),
    status: Type.literal({
        PENDING: 1,
        READY: 1,
        SHIPPED: 1,
        DELIVERED: 1
    })
});
const lineItemSpec = Type.interface({
    productId: Type.string,
    quantity: integerAbove0,
    application: Type.array(Type.literal({
        LEFT_EYE: 1,
        RIGHT_EYE: 1
    }))
});
const paymentMethodSpec = Type.interface({
    type: Type.string,
    details: Type.map(Type.string, Type.string)
});
const pauseOptionSpec = Type.interface({
    amount: integerSpec,
    unit: Type.literal({
        MONTHS: 1
    })
});
const subscriptionSpec = Type.interface({
    id: Type.string,
    expiryDate: isoDateSpec,
    status: Type.literal({
        ACTIVE: 1,
        PAUSED: 1,
        EXPIRED: 1,
        CANCELLED: 1,
        ON_HOLD: 1,
        PENDING: 1
    }),
    pendingChanges: Type.array(Type.literal({
        pause: 1,
        quantity: 1
    })),
    pauseOptions: Type.array(pauseOptionSpec),
    billing: Type.interface({
        totalPricePerInstallment: moneySpec
    }),
    deliveries: Type.array(deliverySpec),
    deliveryFrequency: optional(Type.literal({
        WEEKLY: 1,
        BI_WEEKLY: 1,
        MONTHLY: 1,
        QUARTERLY: 1,
        ANNUALLY: 1
    })),
    deliveryAddress: Type.map(Type.string, Type.string),
    billingAddress: optional(Type.map(Type.string, Type.string)),
    lineItems: Type.array(lineItemSpec),
    paymentMethod: paymentMethodSpec,
    topUpAllowed: Type.boolean,
    quantityChangeable: Type.boolean,
    installments: Type.array(Type.interface({
        date: isoDateSpec,
        totalPrice: moneySpec,
        paymentMethod: Type.string,
        status: Type.literal({
            PAID: 1,
            PENDING: 1,
            CANCELLED: 1,
            FAILED: 1,
            PLANNED: 1
        })
    })),
    custom: optional(Type.map(Type.string, Type.unknown))
});
const subscriptionListItemSpec = Type.interface({
    id: Type.string
});
const subscriptionList = Type.array(subscriptionListItemSpec);
const subscriptionListResponse = Type.interface({
    subscriptions: subscriptionList
});

export { deliverySpec, lineItemSpec, moneySpec, pauseOptionSpec, paymentMethodSpec, subscriptionList, subscriptionListItemSpec, subscriptionListResponse, subscriptionSpec };
//# sourceMappingURL=specs.js.map
